module.exports = __webpack_public_path__ + "assets/img/lian1.2acd7ba6.svg";